import React, { useEffect, useState } from 'react';

import useDetectClickOutSideComponentHook from 'components/common/CustomHook/DetectClickOutSideComponentHook/useDetectClickOutSideComponentHook';

import classes from 'components/App/AuthenticateLayout/Header/Notification/Notification.module.scss';
import NotificationBell from 'components/App/AuthenticateLayout/Header/Notification/NotificationBell/NotificationBell';
import NotificationList from 'components/App/AuthenticateLayout/Header/Notification/NotificationList/NotificationList';

const Notification = () => {
    const [show, setShow] = useState<boolean>(false);
    const { ref, isComponentVisible, setIsComponentVisible } = useDetectClickOutSideComponentHook(show);

    useEffect(() => {
        !isComponentVisible && setShow(false);
    }, [isComponentVisible]);

    const toggleShow = () => {
        setShow(!show);
        setIsComponentVisible(!show);
    };

    return (
        <div className={classes.notificationContainer} ref={ref}>
            <NotificationBell onClick={toggleShow} />
            <NotificationList show={show} />
        </div>
    );
};

export default Notification;
